// Use This for testing
const URL = "testinglims.bfiinfotech.co.in";

export const BASE_URL = `https://${URL}/api/`;
export const DOMAIN = `https://${URL}`;

export const MAX_COLS = 30;
export const G_Value = 9.80665;
export const DEFAULT_MAX_PRECISION = 10;
export const TIME_ZONE_OFFSET = "";
// - INTERVAL 3 HOUR - INTERVAL 30 MINUTE


export const DISABLED_MODULE = [];

export const DISABLED_DISCIPLINE = [];

export const employeeUnicode = "BFI";

export const InwardPDfColumn = 21;

export const InwardhideColumn = ["boreHoleNo", "fromDepth", "toDepth"]; // add key
export const UnicodeCompany = "BFI";

// hide location add only no
// 1:Permanent Facility, 2:Site Facility, 3:Mobile Facility
export const HIDE_LOCATION_OPTIONS = ["2"];